export default __webpack_public_path__ + "static/media/TheGlobalBlueJeans.3bca9a82.png";